import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

// API
export const STROLLERS_BRANDS_LIST_FETCH_TRIGGER = 'STROLLERS_BRANDS_LIST_FETCH_TRIGGER';
export interface BrandsFetchTriggerAction {
    readonly type: typeof STROLLERS_BRANDS_LIST_FETCH_TRIGGER;
    readonly after: string;
}
export const STROLLERS_BRANDS_LIST_FETCH_REQUEST = 'STROLLERS_BRANDS_LIST_FETCH_REQUEST';
export interface BrandsFetchRequestAction extends APIRequestAction {
    readonly type: typeof STROLLERS_BRANDS_LIST_FETCH_REQUEST;
    readonly after: string;
}
export interface BrandsFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { brands: number[]; guideArticles: number[]; strollersCounselling: number; };
}
export const STROLLERS_BRANDS_LIST_FETCH_SUCCESS = 'STROLLERS_BRANDS_LIST_FETCH_SUCCESS';
export interface BrandsFetchSuccessAction extends APISuccessAction<BrandsFetchNormalizedResponse> {
    readonly type: typeof STROLLERS_BRANDS_LIST_FETCH_SUCCESS;
    readonly after: string;
    readonly hasMore: boolean;
}
export const STROLLERS_BRANDS_LIST_FETCH_FAILURE = 'STROLLERS_BRANDS_LIST_FETCH_FAILURE';
export interface BrandsFetchFailureAction extends APIFailureAction {
    readonly type: typeof STROLLERS_BRANDS_LIST_FETCH_FAILURE;
    readonly after: string;
}

export const brandsFetchTrigger = (after?: string): BrandsFetchTriggerAction => ({
    type: STROLLERS_BRANDS_LIST_FETCH_TRIGGER, after,
});
export const brandsFetchApi = {
    request: (after: string): BrandsFetchRequestAction => ({
        type: STROLLERS_BRANDS_LIST_FETCH_REQUEST, after,
    }),
    success: (after: string, hasMore: boolean, response: BrandsFetchNormalizedResponse): BrandsFetchSuccessAction => ({
        type: STROLLERS_BRANDS_LIST_FETCH_SUCCESS, after, hasMore, response,
    }),
    failure: (after: string, error: any): BrandsFetchFailureAction => ({
        type: STROLLERS_BRANDS_LIST_FETCH_FAILURE, after, error,
    }),
};
